export default __webpack_public_path__ + "static/media/g2.2cd2701a.jpg";